'use client';

import { useEffect } from 'react';

export function CopyCodeButton() {
  useEffect(() => {
    const pres = document.querySelectorAll('article pre');

    pres.forEach((pre) => {
      if (pre.querySelector('[data-copy-btn]')) return;
      const el = pre as HTMLElement;
      el.style.position = 'relative';

      const btn = document.createElement('button');
      btn.setAttribute('data-copy-btn', '');
      btn.setAttribute('aria-label', 'Copy code');
      btn.textContent = 'Copy';
      Object.assign(btn.style, {
        position: 'absolute',
        top: '8px',
        right: '8px',
        padding: '2px 8px',
        fontSize: '12px',
        borderRadius: '4px',
        border: '1px solid var(--border, #333)',
        background: 'var(--card, #1a1a2e)',
        color: 'var(--muted-foreground, #aaa)',
        cursor: 'pointer',
        opacity: '0',
        transition: 'opacity 0.2s',
      });

      el.addEventListener('mouseenter', () => { btn.style.opacity = '1'; });
      el.addEventListener('mouseleave', () => {
        if (btn.textContent !== '✓') btn.style.opacity = '0';
      });

      btn.addEventListener('click', async () => {
        const code = pre.querySelector('code');
        await navigator.clipboard.writeText(code?.textContent ?? pre.textContent ?? '');
        btn.textContent = '✓';
        btn.style.opacity = '1';
        btn.style.color = 'var(--primary, #6a3c9e)';
        setTimeout(() => {
          btn.textContent = 'Copy';
          btn.style.color = 'var(--muted-foreground, #aaa)';
          btn.style.opacity = '0';
        }, 2000);
      });

      el.appendChild(btn);
    });
  }, []);

  return null;
}
